<!-- SELECT TAG CONTENT- -->
<div class="tag-notification-dialog-container">
  <ng-template [ngIf]="mode === 'DELETE'" [ngIfElse]="ADD">
    <h1 mat-dialog-title class="dialog-title">Delete Tags</h1>
  </ng-template>
  <ng-template #ADD>
    <h1 mat-dialog-title class="dialog-title">Add Tags</h1>
  </ng-template>
  <mat-dialog-content>
    <div class="notification-send-all-action align-h">
      <div class="stretch">
        <a mat-flat-button (click)="onSelectTags()"> Select All </a>
      </div>
      <a mat-flat-button (click)="onClearTags()"> Clear All </a>
    </div>
    <div class="notification-tag-list">
      <mat-progress-bar
        mode="indeterminate"
        *ngIf="!tagList"
      ></mat-progress-bar>
      <mat-checkbox
        *ngFor="let item of tagList"
        [checked]="tagSelection.isSelected(item)"
        (change)="$event ? tagSelection.toggle(item) : null"
      >
        {{ item.tagName }}
      </mat-checkbox>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button
      tabindex="-1"
      mat-raised-button
      color="basic"
      class="mat-button-medium"
      mat-dialog-close
    >
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      class="mat-button-medium"
      *ngIf="mode === 'DELETE'"
      [disabled]="tagSelection.selected?.length === 0"
      (click)="onDeleteTagDialog(tagSelection.selected, mode)"
    >
      Done
    </button>
    <button
      mat-raised-button
      color="primary"
      class="mat-button-medium"
      *ngIf="mode === 'ADD'"
      [disabled]="tagSelection.selected?.length === 0"
      (click)="onAddUserTagDialog(tagSelection.selected, mode)"
    >
      Done
    </button>
  </mat-dialog-actions>
</div>
